export default "__VITE_ASSET__72f3685a__"